import gif from "../../assets/images/*.gif";
import png from "../../assets/images/*.png";
import * as Constants from '../utils/constants';
const GAMESTATE = Constants.GAMESTATE;

export default class App{
    constructor(game){
        this.game = game;
        
        this.addResultListener();
        this.addShareListener();
    }

    renderInit(){
        document.querySelector("#home-template").classList.remove("render");
        document.querySelector("#result-template").classList.remove("render");
    }

    menu(){
        this.renderHome();
    }   
    
    renderHome(){
        this.renderInit();
        document.querySelector("#home-template").classList.add("render");
    }
    
    renderResult(state = this.game.gameState){
        this.renderInit();
        const result = document.querySelector("#result-template");
        const restartBtn = document.querySelector("#restart-btn");
        const startBtn = document.querySelector("#start-btn");
        const continueBtn = document.querySelector("#continue-btn");
        const shareBtn = document.querySelector("#share-btn");

        restartBtn.classList.add("hide")
        startBtn.classList.add("hide")
        continueBtn.classList.add("hide")
        shareBtn.classList.add("hide");
        result.querySelector("#result-img").classList.add("hide");
        result.classList.add("render");
        
        result.querySelector("#result-title").innerHTML = "";
        result.querySelector("#result-subtitle").innerHTML = "";
        result.querySelector("#result-img").src = png["can"];

        const fullCups = this.game.cups.filter((cup) => { return cup.full});

        switch(state){
            case GAMESTATE.INIT:
                 startBtn.classList.remove("hide");
                 break;
            case GAMESTATE.MISSED:
                result.querySelector("#result-title").innerHTML = "Missed";
                result.querySelector("#result-subtitle").innerHTML = "Awk! You lost a chance";
                result.querySelector("#result-img").src = gif["missed"];
                if(this.game.user.lives > 0){
                    restartBtn.classList.remove("hide")
                }
                break;
            case GAMESTATE.WON:
                result.querySelector("#result-title").innerHTML = "Won";
                if(fullCups.length === 1){
                    result.querySelector("#result-subtitle").innerHTML = "Nice!";
                } else if(fullCups.length === 2) {
                    result.querySelector("#result-subtitle").innerHTML = "Great! One more pour";
                } else {
                    result.querySelector("#result-subtitle").innerHTML = "Awesome!";                    
                }
                result.querySelector("#result-img").src = gif["won"];
                continueBtn.classList.remove("hide");
                break;
            case GAMESTATE.SPILLED:
                result.querySelector("#result-title").innerHTML = "Spilled";
                result.querySelector("#result-subtitle").innerHTML = "Oop! you lost a chance";
                result.querySelector("#result-img").src = gif["spilled"];
                if(this.game.user.lives > 0){
                    restartBtn.classList.remove("hide")
                }
                break;
            case GAMESTATE.CONGRATS:
                result.querySelector("#result-title").innerHTML = "Congratulations";
                result.querySelector("#result-subtitle").innerHTML = "Coffee aficionado, Cheer!";
                result.querySelector("#result-img").src = gif["congrats"];
                shareBtn.classList.remove("hide")
                break;
            case GAMESTATE.GAMEOVER:
                result.querySelector("#result-title").innerHTML = "Waiting Mood";
                setInterval(()=> {
                    result.querySelector("#result-subtitle").innerHTML = `
                        You've exhausted your chance this time. 
                        <h4 class="mt-4">Start again</h4>
                    `;
                }, 1000);
                result.querySelector("#result-img").src = gif["wait"];
                break;
            default:
                restartBtn.classList.remove("hide")
                break;
        }

        if([GAMESTATE.MISSED, GAMESTATE.WON, GAMESTATE.SPILLED, GAMESTATE.CONGRATS].includes(state)){
            result.querySelector("#result-img").classList.remove("hide");
        }
        result.querySelector("#result-img").classList.remove("hide");        
    }

    addNavButton(selector, template){
        document.querySelector(selector).querySelectorAll(".back-btn").forEach((node) => {
            node.addEventListener("click", (e) => {
                e.preventDefault();
                switch(template){
                    case "HOME":
                        this.renderHome();
                        break;
                    default:
                        break;
                }
            });
        })
    }

    addResultListener(){
        const startBtn = document.querySelector(".start-btn");
        const restartBtn = document.querySelector("#restart-btn");
        const homeBtn = document.querySelector("#home-btn");

        startBtn.addEventListener("click", (e) => {
            e.preventDefault();
            this.game.input.sound(this.game.input.startSound);
            this.game.gameState = GAMESTATE.INIT;
            this.game.user = {lives: 3, can: 0};
            this.game.start();
        });

        restartBtn.addEventListener("click", (e) => {
            e.preventDefault();
            this.game.input.sound(this.game.input.startSound);
            this.game.gameState = GAMESTATE.INIT;
            this.game.start();
        });

        homeBtn.addEventListener("click", (e) => {
            e.preventDefault();
            this.game.input.sound(this.game.input.pourSound);
            this.game.gameState = GAMESTATE.INIT;
            this.renderHome();
        });

    }

    addShareListener(){
        document.querySelectorAll(".share-channel").forEach((node) => {
            node.addEventListener("click", (e) => {
                e.preventDefault();
                const shareText = "Hey Coffee Lover, check out this game called Cuffee."
                const shareLink = window.location.origin;
                const shareContent = shareText + " " + shareLink;

                const channel = node.getAttribute("data-channel");
                switch(channel){
                    case "whatsapp":
                        window.open(`whatsapp://send?text=${shareContent}`)
                        break;
                    case "twitter":
                        window.open(`https://twitter.com/intent/tweet?text=${shareContent}`)
                        break;
                    case "copy":
                        navigator.clipboard.writeText(shareContent);
                        this.popUpToast("bg-success", "Copied! You can paste now.");
                        break;
                    default:
                        break;
                }
            });
        })
    }
    popUpToast(color="bg-primary", text="Drink!", time=3000){
        document.querySelector("#notification").innerHTML = `
        <div class="toast show align-items-center text-white ${color} border-0" role="alert" aria-live="assertive" aria-atomic="true">
            <div class="d-flex">
                <div class="toast-body">
                    ${text}
                </div>
                <button type="button" class="btn-close btn-close-white me-2 m-auto" data-bs-dismiss="toast" aria-label="Close"></button>
            </div>
        </div>
        `;
        setTimeout(() => {
            document.querySelector("#notification").innerHTML = "";
        },time)
    }
}